import { combineReducers } from '@reduxjs/toolkit';
import vehicleReducer from '../whitelistBlacklistVehicle/vehicles-slice';
import fileReducer from './fileReducer';
import { assetSlice } from '../Assets/asset-slice';
import { systemSlice } from '../SystemDetail/system-detail-slice';
import { scoreCardSlice } from '../scoreCard/score-card-slice';
import { incidentSlice } from '../Incidents/incident-slice';
import { incidentByAseetIdSlice } from '../asset-specific-incidents/asset-incidents-slice';
import { dashboardSlice } from '../dashboard/dashboard-slice';
import { authSlice } from '../auth/authSlice';
import refreshSlice from '../Refresh/refreshSlice';
import { gpsAndStreamsSlice } from '../gps-and-streams/gps-and-stream-slice';
import { canvasFrameSlice } from '../polygon-canvas/polygon-slice';
import liveStreamSlice from '../livestream/live-stream-slice';
const rootReducer = combineReducers({
    blacklistWhitelistVehicle: vehicleReducer,
    assetsDetail: assetSlice.reducer,
    systemDetail: systemSlice.reducer,
    scoreCardSlice: scoreCardSlice.reducer,
    incidentDetail: incidentSlice.reducer,
    IncidentByAssetId: incidentByAseetIdSlice.reducer,
    dashboardSlice: dashboardSlice.reducer,
    authSlice: authSlice.reducer,
    file: fileReducer,
    refresh: refreshSlice.reducer,
    gpsAndStreams: gpsAndStreamsSlice.reducer,
    canvasFrame: canvasFrameSlice.reducer,
    LiveStreamUrl: liveStreamSlice
});
export default rootReducer;
